// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#error-boundary h1 {
    text-align: center;
}
#error-boundary .error-message .label {
    font-weight: bold;
}

@media (width >= 750px) {
    #error-boundary {
        width: 100%;
        max-width: 700px;
        margin: 50px auto;
    }

}
@media (width < 750px) {
    #error-boundary {
        padding: 0 20px;
        box-sizing: border-box;
        margin: 0 auto;
    }
}
`, "",{"version":3,"sources":["webpack://./client/errors/ErrorBoundary.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;QAChB,iBAAiB;IACrB;;AAEJ;AACA;IACI;QACI,eAAe;QACf,sBAAsB;QACtB,cAAc;IAClB;AACJ","sourcesContent":["#error-boundary h1 {\n    text-align: center;\n}\n#error-boundary .error-message .label {\n    font-weight: bold;\n}\n\n@media (width >= 750px) {\n    #error-boundary {\n        width: 100%;\n        max-width: 700px;\n        margin: 50px auto;\n    }\n\n}\n@media (width < 750px) {\n    #error-boundary {\n        padding: 0 20px;\n        box-sizing: border-box;\n        margin: 0 auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
